module.exports = __webpack_public_path__ + "static/media/phone_reservando.010e8196.png";